/*
 * Instant variantwissel op de productpagina (Bellacombe / Horizon), 2026-10-28.
 * Remco: "en variant switchen", "vetragingen fixen zonder bugs achter te laten", "maximale snelheid".
 *
 * Horizon (assets/variant-picker.js) haalt bij elke wissel de productsectie op en vervangt pas daarna de galerij
 * (media-gallery.js: replaceWith). Foto en kleurnaam veranderden daardoor pas na ~230-300 ms (4G: meer).
 *
 * 1. Bij de klik (change) zet dit script meteen de hoofdfoto van de gekozen variant op de eerste plek van de
 *    zichtbare galerij en de gekozen waarde in het label ("Colour Black"). De server zet daarna precies die foto
 *    vooraan (selected_variant.featured_media), met dezelfde URL's: image_url (snippets/mb-variant-media.liquid)
 *    + &width=N uit de srcset die er al staat. Wat de server even later neerzet is dus gelijk aan wat al staat.
 *    Prijs, voorraad, knoppen en maten blijven volledig van de server.
 * 2. Bij aanraken (pointerdown) of hover (muis, 80 ms) van een optie wordt het verzoek dat Horizon bij de klik
 *    gaat doen al gestart, en de variantfoto voorgeladen. window.fetch geeft Horizon dat antwoord terug als de
 *    URL exact gelijk is (zelfde opbouw als buildRequestUrl). Elk ander verzoek gaat ongewijzigd door.
 *
 * Alles is alleen-voor-de-hoofdproductsectie: niet in productkaarten of quick-add, niet bij combined listings.
 * Valt er iets niet te bepalen (geen foto, onbekend srcset-formaat, video vooraan), dan doet het script niets en
 * werkt alles zoals voorheen.
 */
(function () {
  if (window.__mbVariantInstant) return;
  window.__mbVariantInstant = true;

  var MAP = {};
  try {
    var el = document.getElementById('mb-vmedia');
    if (el) MAP = JSON.parse(el.textContent) || {};
  } catch (e) {
    MAP = {};
  }

  /* ---------- helpers ---------- */

  function mainPicker(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return null;
    var picker = input.closest('variant-picker');
    if (!picker || picker.dataset.templateProductMatch !== 'true') return null;
    if (picker.closest('product-card, quick-add-dialog, quick-add-component, featured-product-information')) return null;
    var current = (picker.dataset.productUrl || '').split('?')[0];
    var connected = input.dataset.connectedProductUrl;
    if (connected && connected.split('?')[0] !== current) return null; // combined listing: ander product
    return picker;
  }

  function widthUrl(base, w) {
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Bouwt de srcset/src voor de variantfoto met dezelfde breedtes als het huidige <img>. null = formaat onbekend. */
  function variantSources(img, base) {
    var srcset = img.getAttribute('srcset') || '';
    var parts = srcset.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!parts.length) return null;
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var m = parts[i].match(/^(\S+)\s+(\d+w)$/);
      if (!m) return null;
      var wm = m[1].match(/[?&]width=(\d+)/);
      if (!wm) return null;
      out.push(widthUrl(base, wm[1]) + ' ' + m[2]);
    }
    var src = img.getAttribute('src') || '';
    var sm = src.match(/[?&]width=(\d+)/);
    return { srcset: out.join(', '), src: sm ? widthUrl(base, sm[1]) : widthUrl(base, 1200) };
  }

  function visible(el) {
    return !!(el && el.offsetWidth > 0 && el.getClientRects().length && !el.closest('dialog'));
  }

  /* Eerste foto van de zichtbare galerij (slider: dia 1; raster: eerste vak) + de slider zelf. */
  function firstMedia(picker) {
    var section = picker.closest('.shopify-section');
    var gallery = section && section.querySelector('media-gallery');
    if (!gallery) return null;
    var shows = gallery.querySelectorAll('slideshow-component');
    for (var i = 0; i < shows.length; i++) {
      if (!visible(shows[i])) continue;
      var slide = shows[i].querySelector('slideshow-slide');
      var img = slide && slide.querySelector('img');
      if (!img || slide.querySelector('video, model-viewer, iframe')) return null;
      return { img: img, slideshow: shows[i] };
    }
    var boxes = gallery.querySelectorAll('.product-media-container');
    for (var j = 0; j < boxes.length; j++) {
      if (!visible(boxes[j])) continue;
      var im = boxes[j].querySelector('img');
      if (!im || boxes[j].querySelector('video, model-viewer, iframe')) return null;
      return { img: im, slideshow: null };
    }
    return null;
  }

  /* ---------- 1. meteen tonen bij de klik ---------- */

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      var picker = mainPicker(input);
      if (!picker) return;
      try {
        var fs = input.closest('fieldset');
        var label = fs && fs.querySelector('.variant-option__swatch-value');
        if (label) label.textContent = input.value;

        var base = MAP[input.dataset.variantId];
        if (!base) return;
        var media = firstMedia(picker);
        if (!media) return;
        var src = variantSources(media.img, base);
        if (!src) return;
        if (media.img.getAttribute('srcset') !== src.srcset) {
          media.img.setAttribute('srcset', src.srcset);
          media.img.setAttribute('src', src.src);
          media.img.removeAttribute('loading');
        }
        var show = media.slideshow;
        if (show && show.current !== 0 && typeof show.select === 'function') {
          show.select(0, undefined, { animate: false });
        }
      } catch (err) {
        /* nooit de echte wissel blokkeren */
      }
    },
    true
  );

  /* ---------- 2. vooraf ophalen bij aanraken / hover ---------- */

  var origFetch = window.fetch.bind(window);
  var cache = new Map();
  var TTL = 20000;

  function requestUrl(picker, input) {
    var section = picker.closest('[id^="shopify-section-"]');
    var productUrl = (picker.dataset.productUrl || '').split('?')[0];
    if (!section || !productUrl || !input.dataset.optionValueId) return null;
    var fieldset = input.closest('fieldset');
    var ids = [];
    var chosen = picker.querySelectorAll('select option[selected], fieldset input:checked');
    for (var i = 0; i < chosen.length; i++) {
      var c = chosen[i];
      if (!c.dataset.optionValueId) return null;
      ids.push(fieldset && c.closest('fieldset') === fieldset ? input.dataset.optionValueId : c.dataset.optionValueId);
    }
    if (!ids.length) return null;
    var params = [];
    var view = new URL(location.href).searchParams.get('view');
    if (view) params.push('view=' + view);
    params.push('option_values=' + ids.join(','));
    return productUrl + '?section_id=' + section.id.replace('shopify-section-', '') + '&' + params.join('&');
  }

  function key(url) {
    try {
      return new URL(url, location.origin).href;
    } catch (e) {
      return url;
    }
  }

  function preloadImage(picker, input) {
    var base = MAP[input.dataset.variantId];
    if (!base) return;
    var media = firstMedia(picker);
    if (!media) return;
    var src = variantSources(media.img, base);
    if (!src) return;
    var im = new Image();
    im.sizes = media.img.getAttribute('sizes') || '100vw';
    im.srcset = src.srcset;
    im.src = src.src;
  }

  function prefetch(input) {
    var picker = mainPicker(input);
    if (!picker || input.checked || input.disabled) return;
    var url = requestUrl(picker, input);
    if (!url) return;
    var k = key(url);
    var hit = cache.get(k);
    if (hit && Date.now() - hit.t < TTL) return;
    var p = origFetch(url, { credentials: 'same-origin' }).then(function (r) {
      return r.text().then(function (text) {
        return { ok: r.ok, status: r.status, statusText: r.statusText, headers: Array.from(r.headers.entries()), text: text };
      });
    });
    p.catch(function () { cache.delete(k); });
    cache.set(k, { t: Date.now(), p: p });
    preloadImage(picker, input);
  }

  window.fetch = function (resource, init) {
    try {
      var url = typeof resource === 'string' ? resource : resource && resource.url;
      if (url && cache.size && url.indexOf('option_values=') > -1) {
        var k = key(url);
        var hit = cache.get(k);
        if (hit && Date.now() - hit.t < TTL) {
          cache.delete(k);
          var signal = init && init.signal;
          return new Promise(function (resolve, reject) {
            if (signal && signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));
            var onAbort = function () { reject(new DOMException('Aborted', 'AbortError')); };
            if (signal) signal.addEventListener('abort', onAbort, { once: true });
            hit.p.then(
              function (d) {
                if (signal) signal.removeEventListener('abort', onAbort);
                if (signal && signal.aborted) return;
                if (!d.ok) return resolve(origFetch(resource, init));
                resolve(new Response(d.text, { status: d.status, statusText: d.statusText, headers: d.headers }));
              },
              function () {
                if (signal) signal.removeEventListener('abort', onAbort);
                if (signal && signal.aborted) return;
                resolve(origFetch(resource, init));
              }
            );
          });
        }
      }
    } catch (e) {
      /* val terug op de gewone fetch */
    }
    return origFetch(resource, init);
  };

  function inputFrom(target) {
    if (!(target instanceof Element)) return null;
    var label = target.closest('variant-picker label');
    if (!label) return target instanceof HTMLInputElement ? target : null;
    var input = label.querySelector('input[type="radio"]');
    if (!input && label.htmlFor) input = document.getElementById(label.htmlFor);
    return input instanceof HTMLInputElement ? input : null;
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      var input = inputFrom(e.target);
      if (input) prefetch(input);
    },
    { capture: true, passive: true }
  );

  var hoverTimer = null;
  document.addEventListener(
    'pointerover',
    function (e) {
      if (e.pointerType !== 'mouse') return;
      var input = inputFrom(e.target);
      clearTimeout(hoverTimer);
      if (!input) return;
      hoverTimer = setTimeout(function () { prefetch(input); }, 80);
    },
    { passive: true }
  );
})();
